"use client";

import { Box, Modal, Typography } from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  border: "4px solid #f1f1f1",
  borderRadius: "8px",
  overflow: "hidden",
  p: 4,
};

export default function ImportHelp({ open, onClose, candidateId }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="modal-modal-title" variant="h3" component="h2">
          Help with failed CV import
        </Typography>
        <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }}>
          The CV import failed. A few suggestions for ensuring a successful import:
          <ul>
            <li>Use original CVs, rather than formatted or anonymised versions</li>
            <li>Use a PDF CV instead of a DOC or DOCX</li>
            <li>For best results, use a CV that is less than 8 pages</li>
            <li>Ensure the CV contains the candidate name and email address</li>
            <li>Avoid cover pages on the CV</li>
          </ul>
          <br />
          <br />
          Try the import again and if it&apos;s still failing,{" "}
          <a
            target="_blank"
            href={`mailto:team@floats.ai?subject=Failed%20CV%20import%20id:%20${candidateId}`}
          >
            let the Floats team know
          </a>
          .
        </Typography>
      </Box>
    </Modal>
  );
}